import { useState, useEffect } from 'react';
import MOCK_PRODUCTS from './mock_response.json';
import { Product, ApiResponse } from './interfaces';

const mockApi = {
    getProducts: async (): Promise<{ data: ApiResponse }> => {
        await new Promise(resolve => setTimeout(resolve, 500));
        return { data: MOCK_PRODUCTS as unknown as ApiResponse };
    }
};

const RevisedStorefront = () => {
    const [products, setProducts] = useState<Product[]>([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        const fetchProducts = async () => {
            try {
                setLoading(true);
                const response = await mockApi.getProducts();
                // Transform the product_by_sku object into an array of Product objects
                const products = Object.entries(response.data.product_by_sku).map(([id, product]) => ({
                    id: parseInt(id, 10),
                    name: product.name,
                    price: product.base_price,
                    description: product.description,
                    image: product.images?.[0] || '',
                }));
                setProducts(products);
                setError(null);
            } catch (err) {
                setError('Failed to fetch products');
                console.error('Error fetching products:', err);
            } finally {
                setLoading(false);
            }
        };

        fetchProducts();
    }, []);

    if (loading) return <div>Loading products...</div>;
    if (error) return <div>Error: {error}</div>;

    return (
        <div className="storefront">
            <h1>Revised Storefront</h1>
        </div>
    );
};

export default RevisedStorefront;
